/**
 * Dé-wrap des réponses du SDK généré — spec §6.4.
 *
 * DEUX niveaux d'enveloppe à ne pas confondre :
 *  1. le client fetch rend `{ data: <body HTTP>, request, response }` ;
 *  2. le body de Hello-Back est lui-même `{ data: … }` (108 réponses sur 113).
 *
 * ⚠️ JAMAIS de dé-wrap global : trois réponses portent des champs FRÈRES de
 * `data` (`keycloakAvailable`, `keycloakErrors`, `keycloakError`), tous porteurs
 * de sens produit — sur celles-là, `body()` est OBLIGATOIRE.
 */

/** Ce que rend le client généré en `throwOnError: true` (les champs frères sont ignorés). */
export type FetchOk<TBody> = { data: TBody };

/** Rend le BODY HTTP complet — enveloppe { data } CONSERVÉE. */
export async function body<TBody>(promise: Promise<FetchOk<TBody>>): Promise<TBody> {
  const result = await promise;
  return result.data;
}

/** Rend la charge utile — les DEUX niveaux dé-wrappés. Cas courant. */
export async function payload<TData>(promise: Promise<FetchOk<{ data: TData }>>): Promise<TData> {
  const result = await promise;
  return result.data.data;
}

/**
 * Liste paginée : `{ items, meta }` — garde `pagination` et consorts.
 * ⚠️ AUCUN APPELANT en session 1 : pas une seule réponse des 114 opérations ne
 * porte `pagination`. Livré pour la suite — ne pas chercher de pagination là où
 * il n'y en a pas.
 */
export async function paged<TItem, TMeta>(
  promise: Promise<FetchOk<{ data: TItem[] } & TMeta>>,
): Promise<{ items: TItem[]; meta: TMeta }> {
  const result = await promise;
  const { data, ...meta } = result.data as { data: TItem[] } & Record<string, unknown>;
  return { items: data, meta: meta as TMeta };
}
